import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Fragment } from 'react';
import { Controller } from 'react-hook-form';

const SearchLinkedMemberInput = ({
	setValue,
	name,
	control,
	options,
	loading = false,
	textFieldProps = {},
	...rest
}) => {
	const handleChange = (event, value) => {
		setValue(name, value);
	};

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={null}
			render={({ field }) => {
				return (
					<Autocomplete
						options={options}
						renderInput={params => (
							<TextField
								{...params}
								variant="outlined"
								{...textFieldProps}
								sx={{
									...textFieldProps.sx,
									'& .MuiAutocomplete-hasClearIcon': {
										paddingBottom: '5px',
										paddingTop: '5px'
									}
								}}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<Fragment>
											{loading ? <CircularProgress color="inherit" size={20} /> : null}
											{params.InputProps.endAdornment}
										</Fragment>
									)
								}}
							/>
						)}
						getOptionLabel={option => {
							return `${option.fullname} (${option.email})`;
						}}
						// * Here is explanation of why we override filterOptions => https://mui.com/material-ui/react-autocomplete/#search-as-you-type
						filterOptions={x => x}
						loading={loading}
						{...rest}
						sx={{
							...rest.sx,
							flexGrow: 1
						}}
						{...field}
						onChange={handleChange}
						isOptionEqualToValue={(option, value) => option.id === value.id}
					/>
				);
			}}
		/>
	);
};

export default SearchLinkedMemberInput;
